// plugins/chart.js

export const shadowLine = {
  id: 'shadowLine',
  afterDatasetsDraw(chart) {
    const { ctx, data } = chart;
    const meta = chart.getDatasetMeta(1);

    if (!meta || !meta.dataset) return;

    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,0.7)';
    ctx.shadowBlur = 6;
    ctx.shadowOffsetY = 2;
    ctx.lineWidth = 2;
    ctx.strokeStyle = '#ffffff';
    ctx.beginPath();
    meta.dataset.draw(ctx, data);
    ctx.restore();
  }
};

export const stripeBg = {
  id: 'stripeBgLight',
  beforeDraw(chart) {
    const y = chart.scales?.y;
    const area = chart.chartArea;
    if (!y || !y.ticks?.length || !area) return;

    const { ctx, chartArea: { left, right, top, bottom } } = chart;

    ctx.save();

    // background
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(left, top, right - left, bottom - top);

    // stripes
    for (let i = 0; i < y.ticks.length - 1; i++) {
      if (i % 2 === 0) {
        const y1 = y.getPixelForTick(i);
        const y2 = y.getPixelForTick(i + 1);

        ctx.fillStyle = 'rgba(0,0,0,0.035)';
        ctx.fillRect(left, y2, right - left, y1 - y2);
      }
    }

    ctx.restore();
  }
};